import type { Product, ProductVariant } from "@/types";

type DbProductLike = {
  id: string;
  title: string;
  slug: string;
  brand: string;
  category: string;
  description: string;
  specifications?: unknown;
  variants?: unknown;
  images: unknown;
  price: number;
  mrp: number;
  discount: number;
  stock: number;
  rating: number;
  reviewCount: number;
  tags: unknown;
  isPrime: boolean;
  isFeatured: boolean;
  isSponsored?: boolean;
  isFlashDeal?: boolean;
  inPromotionBanner?: boolean;
  flashEndsAt?: Date | string | null;
  seller?: string | null;
  warranty?: string | null;
};

function parseStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map((item) => String(item).trim()).filter(Boolean);
      }
    } catch {
      if (value.trim()) return [value.trim()];
    }
  }
  return [];
}

export function serializeProduct(product: DbProductLike): Product {
  return {
    id: product.id,
    title: product.title,
    slug: product.slug,
    brand: product.brand,
    category: product.category,
    description: product.description,
    specifications: (product.specifications as Record<string, string> | null | undefined) ?? undefined,
    variants: Array.isArray(product.variants) ? (product.variants as ProductVariant[]) : [],
    images: parseStringArray(product.images),
    price: product.price,
    mrp: product.mrp,
    discount: product.discount,
    stock: product.stock,
    rating: product.rating,
    reviewCount: product.reviewCount,
    tags: parseStringArray(product.tags),
    isPrime: product.isPrime,
    isFeatured: product.isFeatured,
    isSponsored: product.isSponsored ?? false,
    isFlashDeal: product.isFlashDeal ?? false,
    inPromotionBanner: product.inPromotionBanner ?? false,
    flashEndsAt: product.flashEndsAt ? new Date(product.flashEndsAt).toISOString() : undefined,
    seller: product.seller ?? undefined,
    warranty: product.warranty ?? undefined
  };
}
